export const FORM_NOT_ATTEMPTED_YET_EMPTY_PROPS = {
  imgSrc: "assets/vectors/recorded_content/empty_form.svg",
  title: "Form not attempted yet.",
  description:
    "Once the student attempts the form, all the responses for the form will get collected here.",
};
